(ns nl.mediquest.questionnaire-frontend.component.notifications
  (:require
   [nl.mediquest.ui.core.notifications :as notifications]
   [re-frame.core :as re-frame]))

(defn render-notifications []
  (let [notifications
        (re-frame/subscribe
         [:nl.mediquest.ui.core.notifications/notifications])]
    [:div.absolute.w-full.z-50.pointer-events-none
     [:div.p-4.w-full.pt-16
      (doall
       (for [notification @notifications]
         ^{:key (:notification/id notification)}
         [notifications/render-notification notification nil]))]]))
